import { render } from "./AccountSetting.vue?vue&type=template&id=7bcd3059&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"

import "./AccountSetting.vue?vue&type=style&index=0&id=7bcd3059&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bcd3059"

export default script